import MoonIcon from "lucide-react/dist/esm/icons/moon";
import SearchIcon from "lucide-react/dist/esm/icons/search";
import SunIcon from "lucide-react/dist/esm/icons/sun";

import { Button } from "@/components/ui/button";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip";
import type { Theme } from "@/lib/theme";

interface AppTopbarProps {
  onOpenCommandPalette: () => void;
  theme: Theme;
  onToggleTheme: () => void;
  /** どの環境を見ているかの取り違えは事故に直結するため常時表示する */
  environment: string;
  apiBaseUrl: string;
}

export function AppTopbar({
  onOpenCommandPalette,
  theme,
  onToggleTheme,
  environment,
  apiBaseUrl
}: AppTopbarProps) {
  return (
    <header className="sticky top-0 z-40 flex h-(--topbar-h) shrink-0 items-center gap-3 border-b border-line bg-surface px-4">
      <button
        type="button"
        onClick={onOpenCommandPalette}
        className="flex h-7 w-full max-w-80 items-center gap-2 rounded-md border border-line bg-canvas px-2 text-left text-xs text-fg-subtle transition-colors hover:border-line-strong hover:text-fg-muted"
      >
        <SearchIcon className="size-3.5 shrink-0" aria-hidden="true" />
        <span className="min-w-0 flex-1 truncate">画面移動・絞り込みを検索</span>
        <kbd className="num rounded-sm border border-line bg-surface px-1 text-[10px] text-fg-subtle">
          ⌘K
        </kbd>
      </button>

      <div className="ml-auto flex shrink-0 items-center gap-2">
        <Tooltip>
          <TooltipTrigger
            render={
              <span className="inline-flex h-6 items-center gap-1.5 rounded-md border border-line bg-canvas px-2 text-2xs font-semibold text-fg-muted">
                <span aria-hidden="true" className="size-1.5 rounded-full bg-neutral" />
                {environment}
              </span>
            }
          />
          <TooltipContent side="bottom">接続先: {apiBaseUrl}</TooltipContent>
        </Tooltip>

        <Tooltip>
          <TooltipTrigger
            render={
              <Button
                type="button"
                variant="ghost"
                size="icon-sm"
                onClick={onToggleTheme}
                aria-label={theme === "dark" ? "ライトテーマに切り替え" : "ダークテーマに切り替え"}
              >
                {theme === "dark" ? (
                  <SunIcon aria-hidden="true" />
                ) : (
                  <MoonIcon aria-hidden="true" />
                )}
              </Button>
            }
          />
          <TooltipContent side="bottom">テーマを切り替え</TooltipContent>
        </Tooltip>

        <span className="grid size-6 place-items-center rounded-full bg-surface-sunken text-2xs font-semibold text-fg-muted">
          <span aria-hidden="true">OP</span>
          <span className="sr-only">ログイン中: 運用チーム</span>
        </span>
      </div>
    </header>
  );
}
